/* HypeScent NS — global behaviours (header, drawer, announcement, rails, tabs, reveal, quick add). */
(function () {
  'use strict';
  var d = document;

  /* ---------- announcement rotation ---------- */
  d.querySelectorAll('[data-ns-announce]').forEach(function (root) {
    var msgs = root.querySelectorAll('.ns-announce__msg');
    if (msgs.length < 2) {
      root.querySelectorAll('.ns-announce__arrow').forEach(function (b) { b.style.visibility = 'hidden'; });
      return;
    }
    var i = 0, timer = null, every = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    function show(n) {
      msgs[i].classList.remove('is-active');
      i = (n + msgs.length) % msgs.length;
      msgs[i].classList.add('is-active');
    }
    function start() { stop(); timer = setInterval(function () { show(i + 1); }, every); }
    function stop() { if (timer) clearInterval(timer); }
    root.querySelector('[data-ns-announce-prev]').addEventListener('click', function () { show(i - 1); start(); });
    root.querySelector('[data-ns-announce-next]').addEventListener('click', function () { show(i + 1); start(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  });

  /* ---------- sticky header ---------- */
  var wrap = d.querySelector('[data-ns-header]');
  var spacer = d.querySelector('[data-ns-header-spacer]');
  if (wrap) {
    var threshold = 0, inFlow = true, flowHeight = 0;
    /* the header sticks as soon as the announcement bar has scrolled away (like Native); when it sits in
       the page flow, a spacer of its exact height keeps the content from jumping */
    function measure() {
      if (wrap.classList.contains('is-stuck')) return;
      var announce = d.querySelector('.ns-announce');
      inFlow = getComputedStyle(wrap).position !== 'absolute';
      flowHeight = wrap.offsetHeight;
      threshold = (announce ? announce.offsetHeight : 0) + (inFlow ? 0 : 12);
    }
    function onScroll() {
      var stuck = window.scrollY > threshold;
      if (stuck === wrap.classList.contains('is-stuck')) return;
      if (stuck) measure();
      if (stuck && spacer && inFlow) spacer.style.height = flowHeight + 'px';
      wrap.classList.toggle('is-stuck', stuck);
      if (!stuck && spacer) spacer.style.height = '';
    }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- mega menus (Native-style: open on hover, full-width panel, first tap opens on touch) ---------- */
  var headWrap = d.querySelector('[data-ns-header]');
  var megaItems = Array.prototype.slice.call(d.querySelectorAll('[data-ns-mega]'));
  if (headWrap && megaItems.length) {
    var navItems = Array.prototype.slice.call(d.querySelectorAll('.ns-nav__item'));
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    var desktop = window.matchMedia('(min-width: 990px)');
    var setTop = function () {
      var h = headWrap.querySelector('.ns-header');
      if (h) headWrap.style.setProperty('--ns-mega-top', Math.max(0, Math.round(h.getBoundingClientRect().bottom)) + 'px');
    };
    var closeAll = function () {
      megaItems.forEach(function (i) { i.classList.remove('is-open'); var l = i.querySelector('.ns-nav__link'); if (l) l.setAttribute('aria-expanded', 'false'); });
      headWrap.classList.remove('is-mega');
    };
    var openItem = function (item) {
      if (!desktop.matches) return;
      megaItems.forEach(function (i) { if (i !== item) { i.classList.remove('is-open'); var l = i.querySelector('.ns-nav__link'); if (l) l.setAttribute('aria-expanded', 'false'); } });
      setTop();
      item.classList.add('is-open');
      item.querySelector('.ns-nav__link').setAttribute('aria-expanded', 'true');
      headWrap.classList.add('is-mega');
    };
    /* hover intent: open at once when nothing is open; when a panel is already open, wait a moment before
       switching so a diagonal move towards a tile does not flip to the neighbouring menu */
    var switchTimer = null;
    var anyOpen = function () { return megaItems.some(function (i) { return i.classList.contains('is-open'); }); };
    navItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        if (!canHover.matches) return;
        clearTimeout(switchTimer);
        var go = function () { if (item.hasAttribute('data-ns-mega')) openItem(item); else closeAll(); };
        if (item.classList.contains('is-open')) return;
        if (anyOpen()) switchTimer = setTimeout(go, 140); else go();
      });
      item.addEventListener('mouseleave', function () { clearTimeout(switchTimer); });
    });
    headWrap.addEventListener('mouseleave', function () { if (canHover.matches) { clearTimeout(switchTimer); closeAll(); } });
    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !headWrap.classList.contains('is-mega')) return;
      var open = megaItems.filter(function (i) { return i.classList.contains('is-open'); })[0];
      var hadFocus = open && open.contains(d.activeElement);
      closeAll();
      if (hadFocus) open.querySelector('.ns-nav__link').focus();
    });
    megaItems.forEach(function (item) {
      var link = item.querySelector('.ns-nav__link');
      link.addEventListener('click', function (e) {
        // touch screens: the first tap opens the panel, the second follows the link
        if (!canHover.matches && desktop.matches && !item.classList.contains('is-open')) { e.preventDefault(); openItem(item); }
      });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ') {
          e.preventDefault(); openItem(item);
          var first = item.querySelector('.ns-mega a');
          if (first) first.focus();
        }
      });
      /* keyboard: Shift+Tab back into a panel reopens it; focus leaving the item closes it */
      var panel = item.querySelector('.ns-mega');
      if (panel) panel.addEventListener('focusin', function () { if (!item.classList.contains('is-open')) openItem(item); });
      item.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !item.contains(e.relatedTarget)) { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); if (!anyOpen()) headWrap.classList.remove('is-mega'); }
      });
    });
    d.addEventListener('click', function (e) { if (!headWrap.contains(e.target)) closeAll(); });
    window.addEventListener('scroll', function () { if (headWrap.classList.contains('is-mega')) setTop(); }, { passive: true });
    desktop.addEventListener && desktop.addEventListener('change', closeAll);
  }

  /* ---------- highlighter on free perks in the curated bundles and the mix builder ----------
     (the body wash / soap / roll-on pack cards get it from hs-bundle-ui.js). Their scripts redraw the
     markup, so a light observer re-applies it; already-marked text is skipped, so it never loops. */
  var HL_RE = /\b\d+\+?\s+free\s+(?:samples?|soaps?)\b/gi;
  var HL_SKIP = 'mark.ns-hl, script, style, h1, h2, h3, .atc, [aria-hidden="true"], .mx-free-badge, .cb-sample-free';
  function highlight(root) {
    var walker = d.createTreeWalker(root, NodeFilter.SHOW_TEXT), nodes = [];
    while (walker.nextNode()) {
      var n = walker.currentNode;
      HL_RE.lastIndex = 0;
      if (n.parentElement && !n.parentElement.closest(HL_SKIP) && HL_RE.test(n.textContent)) nodes.push(n);
    }
    nodes.forEach(function (n) {
      var text = n.textContent, frag = d.createDocumentFragment(), last = 0, m;
      HL_RE.lastIndex = 0;
      while ((m = HL_RE.exec(text))) {
        if (m.index > last) frag.appendChild(d.createTextNode(text.slice(last, m.index)));
        var mark = d.createElement('mark'); mark.className = 'ns-hl'; mark.textContent = m[0]; frag.appendChild(mark);
        last = m.index + m[0].length;
      }
      if (last < text.length) frag.appendChild(d.createTextNode(text.slice(last)));
      n.parentNode.replaceChild(frag, n);
    });
  }
  d.querySelectorAll('[data-curated-bundle], [data-hs-mix]').forEach(function (root) {
    var queued = false;
    var run = function () { queued = false; highlight(root); };
    highlight(root);
    new MutationObserver(function () { if (!queued) { queued = true; requestAnimationFrame(run); } }).observe(root, { childList: true, subtree: true, characterData: true });
  });

  /* ---------- mobile drawer ---------- */
  var drawer = d.querySelector('[data-ns-drawer]');
  if (drawer) {
    var opener = d.querySelector('[data-ns-drawer-open]');
    function openDrawer() { d.documentElement.classList.add('ns-drawer-open'); drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); if (opener) opener.setAttribute('aria-expanded', 'true'); d.documentElement.style.overflow = 'hidden'; }
    function closeDrawer() { d.documentElement.classList.remove('ns-drawer-open'); drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); if (opener) opener.setAttribute('aria-expanded', 'false'); d.documentElement.style.overflow = ''; }
    if (opener) opener.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-ns-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    /* capture phase: the quiz opener stops propagation, the drawer must still close behind it */
    window.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-ns-drawer] a')) closeDrawer(); }, true);
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---------- rails (horizontal carousels) ---------- */
  function initRail(rail) {
    if (rail.__nsRail) return; rail.__nsRail = true;
    var track = rail.querySelector('.ns-rail__track');
    var prev = rail.querySelector('.ns-rail__arrow--prev');
    var next = rail.querySelector('.ns-rail__arrow--next');
    var bar = rail.querySelector('.ns-rail__progress span');
    if (!track) return;
    function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 20) : 300; }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.hidden = track.scrollLeft <= 4;
      if (next) next.hidden = track.scrollLeft >= max - 4;
      if (bar) {
        var ratio = track.clientWidth / Math.max(track.scrollWidth, 1);
        bar.style.width = Math.max(ratio * 100, 12) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 / Math.max(ratio, .12)) - 1) * 100 : 0) + '%)';
      }
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  d.querySelectorAll('.ns-rail').forEach(initRail);

  /* ---------- tabs ---------- */
  d.querySelectorAll('[data-ns-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('[role="tab"]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.classList.toggle('is-active', on);
          t.tabIndex = on ? 0 : -1;
          var panel = d.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
          if (on && panel) panel.querySelectorAll('.ns-rail').forEach(function (r) { r.__nsRail = false; initRail(r); });
        });
      });
      tab.addEventListener('keydown', function (e) {
        var list = Array.prototype.slice.call(tabs), idx = list.indexOf(tab);
        if (e.key === 'ArrowRight') { list[(idx + 1) % list.length].focus(); list[(idx + 1) % list.length].click(); }
        if (e.key === 'ArrowLeft') { list[(idx - 1 + list.length) % list.length].focus(); list[(idx - 1 + list.length) % list.length].click(); }
      });
    });
  });

  /* ---------- trust marquee pause ---------- */
  d.querySelectorAll('[data-ns-marquee-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var root = btn.closest('.ns-trust');
      var paused = root.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.querySelector('.ns-ico-play').hidden = !paused;
      btn.querySelector('.ns-ico-pause').hidden = paused;
    });
  });

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    d.querySelectorAll('.ns-reveal').forEach(function (el) { io.observe(el); });
  } else {
    d.querySelectorAll('.ns-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- cart: count + open ---------- */
  function setCount(n) {
    d.querySelectorAll('[data-ns-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); });
  }
  function refreshCount() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); return c; })
      .catch(function () {});
  }
  window.nsRefreshCartCount = refreshCount;
  window.nsOpenCart = function () {
    if (typeof window.hsCartOpen === 'function') { window.hsCartOpen(); return true; }
    return false;
  };
  d.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ns-cart-open]');
    if (!t) return;
    if (window.nsOpenCart()) e.preventDefault();
  });
  ['cart:updated', 'cart:refresh', 'hs:cart:updated', 'hs-cart:updated'].forEach(function (ev) {
    d.addEventListener(ev, function () { refreshCount(); });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
  d.querySelectorAll('[data-ns-cart-count]').forEach(function (el) {
    new MutationObserver(function () { el.setAttribute('data-count', (el.textContent || '0').trim()); }).observe(el, { childList: true, characterData: true, subtree: true });
  });

  /* ---------- theme preview: reserve room for Shopify's preview bar (absent on the published site) ---------- */
  function measurePreviewBar() {
    var pb = d.getElementById('PBarNextFrameWrapper') || d.getElementById('preview-bar-iframe');
    var h = 0;
    if (pb) { var r = pb.getBoundingClientRect(); if (r.height > 0 && r.height < 160 && r.bottom >= innerHeight - 2) h = Math.round(r.height); }
    d.documentElement.style.setProperty('--ns-pbar-h', h + 'px');
  }
  measurePreviewBar(); [800, 2000, 4000, 8000].forEach(function (t) { setTimeout(measurePreviewBar, t); });
  window.addEventListener('resize', measurePreviewBar);

  /* ---------- quiz links ---------- */
  d.addEventListener('click', function (e) {
    var q = e.target.closest('[data-ns-quiz-open]');
    if (!q) return;
    if (typeof window.hsQuizOpen === 'function') { e.preventDefault(); window.hsQuizOpen(); }
  });
})();
